import Vue from 'vue'
import VueRouter from 'vue-router'
import WaterfallFeed from '../components/WaterfallFeed.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: WaterfallFeed
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router 